import * as React from 'react';
import { ErpRevenueResponse, PackMonthDataResponse } from 'com.cogvio.pricemonitor.api';

import { PriceBadgeRevenue } from './PriceBadgeRevenue';
import { PriceBadgeAverage } from './PriceBadgeAverage';

interface PriceSummaryProps {
	currency: string;
	cumulativeRevenues: ErpRevenueResponse[];
	monthData: PackMonthDataResponse[];
	type?: 'big' | 'small';
}

export function PriceSummary({ currency, cumulativeRevenues, monthData, type }: PriceSummaryProps) {
	return (
		<div className='mb-2'>
			<PriceBadgeRevenue currency={currency} cumulativeRevenues={cumulativeRevenues} type={type} />
			<PriceBadgeAverage currency={currency} monthData={monthData} type={type} />
		</div>
	);
}
